import { createSlice } from "@reduxjs/toolkit";
import { PagesMetadata } from "src/@types/pagesMetadata";
import { METADATA_SLICE_NAME } from "./actions";
import { getMetaDataReducer } from "./reducers";

export interface IMetaDataState {
  isLoading: boolean;
  data: PagesMetadata;
}

const initialState: IMetaDataState = {
  isLoading: false,
  data: null,
};

export const { reducer: metadata } = createSlice({
  name: METADATA_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getMetaDataReducer(builder);
  },
});
